import React from "react";
export default function DemoHeaderOverlay({enabled}) {
  return enabled ? <div role="status" title="New DOs are demo only. Editing existing production records still changes production."
    style={{position: "relative", minHeight: 24, boxSizing: "border-box", fontSize: 12, background: "#ffc107", color: "#302400", textAlign: "center", fontWeight: 800, letterSpacing: "0.12em", padding: "3px 12px", zIndex: 2}}>DEMO MODE ON</div> : null;
}
